import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";

export const teamData = [
  {
    name: "Paresh Deshmukh",
    role: "Co-Founder & CEO",
    image: "Paresh-Deshmukh.png",
    bgColor: "bg-green-100",
    socialLinks: [
      {
        platform: "twitter",
        icon: <FaXTwitter />,
        link: "https://x.com/pareshmukh",
      },
    ],
  },
  {
    name: "Chirag Gupta",
    role: "Co Founder & CTO",
    image: "Chirag-Gupta.png",
    bgColor: "bg-red-100",
    socialLinks: [
      {
        platform: "twitter",
        icon: <FaXTwitter />,
        link: "https://x.com/chigup36",
      },
    ],
  },
  {
    name: "Ayush Bobale",
    role: "Senior Full Stack Developer",
    image: "Ayush-Bobale.png",
    bgColor: "bg-blue-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },
  {
    name: "Jenefa Regina Mary",
    role: "Business Development",
    image: "Jenefa-Regina-Mary.png",
    bgColor: "bg-lime-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },
  {
    name: "Ishika Pippal",
    role: "Business Development",
    image: "Ishika-Pippal.png",
    bgColor: "bg-lime-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },
  {
    name: "Rida Ahsan",
    role: "Business Development",
    image: "Rida-Ahsan.png",
    bgColor: "bg-green-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },

  {
    name: "Arian Shaikh",
    role: "Full Stack Developer",
    image: "Arian-Shaikh.png",
    bgColor: "bg-green-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },
  {
    name: "Rahul Batra",
    role: "Full Stack developer",
    image: "Rahul-Batra.png",
    bgColor: "bg-violet-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },

  {
    name: "Yash Kumar Saini",
    role: "Full Stack Developer",
    image: "Yash-Kumar-Saini.png",
    bgColor: "bg-yellow-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },
  {
    name: "Satyam Raj",
    role: "Full Stack Developer",
    image: "Satyam-Raj.png",
    bgColor: "bg-slate-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },
  {
    name: "Firoz Akhter",
    role: "Full Stack developer",
    image: "Firoz-Akhter.png",
    bgColor: "bg-violet-100",
    socialLinks: [
      // {
      //     platform:"linkedin",
      //     icon:<FaLinkedinIn />,
      //     link:""
      // },
      // {
      //     platform:"twitter",
      //     icon:<FaXTwitter />,
      //     link:""
      // },
    ],
  },
  {
    name: "Roshan (Ross)",
    role: "Senior Customer Success Executive",
    image: "Roshan.png",
    bgColor: "bg-green-100",
    socialLinks: [],
  },
];
